<template>
  <ul class="recursive-list" style="list-style: none; color: darkblue;font-weight: bolder">
    <li @click="dataBack(breadCrumb[0])">
      {{ breadCrumb[0].title }}
    </li>
    <li v-if="breadCrumb.length>1">
      <recursive-component :bread-crumb="breadCrumb.slice(1,breadCrumb.length)" :data-back="dataBack"/>
    </li>
  </ul>
</template>

<script>
export default {
  name: "recursiveComponent",

  props: {
    breadCrumb: {
      default: () => {
        return [];
      }
    },
    dataBack: {
      require: true
    }
  }
}
</script>

<style scoped>
ul > li {
  list-style: none;
  padding-inline: 3rem;
  padding-block: .5rem;
  width: fit-content;
  border-bottom: 1px solid var(--v-primary-base);
}
</style>